import { Button, CircularProgress, Grid } from '@material-ui/core'
import {
  AttachMoney,
  Bookmark,
  Event,
  HourglassEmpty,
  Person,
  Room,
} from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getActivityByProject } from '../../../actions/activityActions'
import {
  addPurchaseOrderDocs,
  getProjectDetails,
} from '../../../actions/projectActions'
import { ReactComponent as ChatIcon } from '../../../assets/img/icons/comments.svg'
import customCircleCheck from '../../../assets/img/icons/ic-check-circle.png'
import { PROJECT_DOCUMENT_SIGNED_RESET } from '../../../constants/projectConstants'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import { useInput } from '../../../hooks/useInput'
import SingleFileDisplay from '../../Form/SingleFileDisplay'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ToastMessage from '../../ToastMessage/ToastMessage'
import AdditionalCharge from './AdditionalCharge'
import ProjectDeliverables from './ProjectDeliverables'
import ProjectSignAndPay from './ProjectSignAndPay'
import RevisionsModal from './RevisionsModal'
import SignAcceptanceCriteriaRevision from './SignAcceptanceCriteriaRevision'

export const PAYMENT_METHODS = {
  CREDIT_CARD: 'Credit card',
  PURCHASE_ORDER: 'Purchase order',
}

let signaturePoll
const ProjectActionsUser = ({ setShowActivityPanel }) => {
  const dispatch = useDispatch()

  const [showSignAndPayModal, setShowSignAndPayModal] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [showRevisionsModal, setShowRevisionsModal] = useState(false)
  const [poDocsAddedToast, setPoDocsAddedToast] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [paymentMethod, setPaymentMethod] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [paymentError, setPaymentError] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [processingPayment, setProcessingPayment] = useState(false)
  const { bind: bindPurchaseOrderNumber, value: purchaseOrderNumber } =
    useInput('')
  const { value: purchaseOrderFiles, setValue: setPurchaseOrderFiles } =
    useInput([])

  const { project } = useSelector((state) => state.projectDetails)

  const { success: addPODocsSuccess } = useSelector(
    (state) => state.projectAddPODocs
  )

  const { success: docSignedSuccess } = useSelector(
    (state) => state.projectDocumentSigned
  )
  const readableDueDate = useDateFormatter(
    project ? project.dueDate : '',
    'MM-DD-YYYY'
  )
  const acceptanceCriteriaUpdatedAt = useDateFormatter(
    project.acceptanceCriteria && project.acceptanceCriteria.length > 0
      ? project.acceptanceCriteria[project.acceptanceCriteria.length - 1]
          .updatedAt
      : ''
  )

  const additionalCharge =
    project.charges &&
    project.charges.length > 1 &&
    (!project.purchaseOrderNumber ||
      project.purchaseOrderNumber === undefined) &&
    !project.charges[project.charges.length - 1].isPaid
      ? project.charges[project.charges.length - 1].price
      : false

  const [revisionAvailable, setRevisionAvailable] = useState(
    project.acceptanceCriteria &&
      project.acceptanceCriteria.length > 1 &&
      !project.acceptanceCriteria[project.acceptanceCriteria.length - 1]
        .isSigned
      ? true
      : false
  )
  const signatureProcessing =
    project.acceptanceCriteria &&
    project.acceptanceCriteria.length > 0 &&
    project.acceptanceCriteria[project.acceptanceCriteria.length - 1]
      .signatureProcessing

  useEffect(() => {
    // if we have a signature processing
    if (
      project.acceptanceCriteria &&
      project.acceptanceCriteria.length > 0 &&
      project.acceptanceCriteria[project.acceptanceCriteria.length - 1]
        .signatureProcessing
    ) {
      clearTimeout(signaturePoll)

      signaturePoll = setTimeout(() => {
        dispatch(getProjectDetails(project._id))
      }, 15 * 1000) // Poll every 15 seconds to see if there are updates
    } else {
      if (signaturePoll) {
        clearTimeout(signaturePoll)
        signaturePoll = null
      }
    }
    return () => clearTimeout(signaturePoll)
  }, [dispatch, project])

  const [revisionIsSigned, setRevisionIsSigned] = useState(false)

  const previousUpdatedAt = useDateFormatter(
    revisionAvailable
      ? project.acceptanceCriteria[project.acceptanceCriteria.length - 2]
          .updatedAt
      : ''
  )

  useEffect(() => {
    if (addPODocsSuccess) {
      setShowSignAndPayModal(false)
      setPoDocsAddedToast(true)
      dispatch(getActivityByProject(project._id))
      dispatch(getProjectDetails(project._id))
    }
  }, [project, dispatch, addPODocsSuccess])

  useEffect(() => {
    if (docSignedSuccess) {
      dispatch({ type: PROJECT_DOCUMENT_SIGNED_RESET })
      setRevisionAvailable(false)
      setRevisionIsSigned(true)
      dispatch(getProjectDetails(project._id))
    }
  }, [docSignedSuccess, dispatch, project])

  const handleProceedClick = () => {
    let projectClone = project

    projectClone.purchaseOrderNumber = purchaseOrderNumber
    projectClone.purchaseOrderFiles = purchaseOrderFiles
    projectClone.status = 'In progress'

    dispatch(addPurchaseOrderDocs(projectClone))
  }

  return (
    <>
      {project.status === 'Quote submitted' && (
        <>
          <h2 className="primary-text m-t-32">Review quote</h2>
          <p>
            See details below, then hit ‘start to proceed’ to continue with
            service agreement signature and payment.
          </p>
        </>
      )}

      {project.status === 'Submitted for review' ? (
        <>
          <h2 className="primary-text m-t-32">Quote request submitted.</h2>
          <p>
            A Hexagon application engineer will be in touch shortly. Meanwhile,
            you can add files if necessary. You can also leave comments for your
            future assignee under the “Activity” panel.
          </p>
          <Button
            variant="outlined"
            className="m-r-16"
            onClick={() => setShowActivityPanel(true)}
          >
            <ChatIcon className="m-r-5" /> Open activity
          </Button>
        </>
      ) : (
        <div className="quote-details">
          <h4>Quote details</h4>

          <Grid container spacing={0} className="input-row m-t-15">
            <Grid item xs={4} className="label-item">
              <Room fontSize="small" />
              <h5>Location</h5>
            </Grid>

            <Grid item xs={8} className="input-item">
              {project.location}
            </Grid>
          </Grid>

          <Grid container spacing={0} className="input-row">
            <Grid item xs={4} className="label-item">
              <Person fontSize="small" />
              <h5>Assignee</h5>
            </Grid>

            <Grid item xs={8} className="input-item">
              {project.assigneeName}
            </Grid>
          </Grid>

          <Grid container spacing={0} className="input-row">
            <Grid item xs={4} className="label-item">
              <Event fontSize="small" />
              <h5>Due date</h5>
            </Grid>

            <Grid item xs={8} className="input-item">
              {readableDueDate}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            className={`input-row ${
              project.charges && project.charges.length > 0
                ? 'no-height m-t-16'
                : ''
            }`}
            style={{ height: 88 }}
          >
            <Grid item xs={12} className="label-item">
              <AttachMoney fontSize="small" />
              <h5>Price</h5>
            </Grid>

            {additionalCharge && (
              <AdditionalCharge
                charge={additionalCharge}
                handleProceedClick={handleProceedClick}
                bindPurchaseOrderNumber={bindPurchaseOrderNumber}
                purchaseOrderFiles={purchaseOrderFiles}
                setPurchaseOrderFiles={setPurchaseOrderFiles}
                setPaymentMethod={setPaymentMethod}
                paymentError={paymentError}
                purchaseOrderNumber={purchaseOrderNumber}
                processingPayment={processingPayment}
              />
            )}

            {project.charges && project.charges.length > 0 && (
              <Grid item xs={12} className="m-t-10 m-b-16">
                <div className="flex column-reverse">
                  {project.charges.length > 1 && (
                    <>
                      <div className="align-center flex gray-text space-between">
                        <div className="fs14 flex">
                          <div className="m-r-10" style={{ width: 60 }}>
                            Total:
                          </div>
                          {project.charges
                            .reduce((acc, cur) => acc + cur.price, 0)
                            .toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                        </div>
                      </div>
                      <div
                        className="gradient-bg m-t-5 m-b-5"
                        style={{ height: 2, width: 160 }}
                      ></div>
                    </>
                  )}

                  {project.charges.map((x, index) => (
                    <div
                      key={index}
                      className="align-center flex gray-text space-between"
                    >
                      <div className="fs14 flex">
                        <div className="m-r-10" style={{ width: 60 }}>
                          {index === 0 ? 'Initial' : 'Added'}:
                        </div>
                        {x.price.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                        })}
                      </div>
                      <div className="fs14">
                        {x.isPaid ? (
                          <div className="paid">
                            <img
                              src={customCircleCheck}
                              alt="Circle Check"
                              style={{ width: 14 }}
                            />{' '}
                            Paid
                          </div>
                        ) : project.purchaseOrderNumber ? (
                          <>
                            <HourglassEmpty style={{ width: 14 }} />
                            Pending AE review
                          </>
                        ) : (
                          <>
                            <HourglassEmpty style={{ width: 14 }} />
                            Pending payment
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={0} className="input-row">
            <Grid item xs={12} className="label-item m-t-16 m-b-8">
              <Bookmark fontSize="small" />
              <h5>Service agreement</h5>
            </Grid>
            {revisionAvailable && (
              <SignAcceptanceCriteriaRevision
                file={
                  project.acceptanceCriteria[
                    project.acceptanceCriteria.length - 1
                  ]
                }
              />
            )}
            <Grid item xs={12} className="input-item">
              <div style={{ maxWidth: '100%' }}>
                <div className="fs14 m-b-5 flex space-between align-center">
                  {revisionAvailable ? (
                    <>
                      <div>{previousUpdatedAt}</div>
                      <div className="align-center flex flex-end gray-text ">
                        <div className="signed text-right">
                          <img
                            src={customCircleCheck}
                            alt="Circle Check"
                            style={{ width: 14 }}
                          />{' '}
                          Signed
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>{acceptanceCriteriaUpdatedAt}</div>
                      <div className="align-center flex flex-end gray-text ">
                        {signatureProcessing ? (
                          <div
                            className="align-center flex flex-end gray-text"
                            style={{ flexGrow: 0 }}
                          >
                            <div
                              style={{
                                position: 'relative',
                                width: 14,
                                height: 14,
                              }}
                            >
                              <CircularProgress
                                variant="indeterminate"
                                className="loader"
                                size={14}
                                style={{ left: 0, top: '0px' }}
                              />
                            </div>
                            <div className="m-l-5">Processing</div>
                          </div>
                        ) : (project.acceptanceCriteria &&
                            project.acceptanceCriteria.length > 0 &&
                            project.acceptanceCriteria[
                              project.acceptanceCriteria.length - 1
                            ].isSigned) ||
                          revisionIsSigned ? (
                          <div className="signed text-right">
                            <img
                              src={customCircleCheck}
                              alt="Circle Check"
                              style={{ width: 14 }}
                            />{' '}
                            Signed
                          </div>
                        ) : (
                          <>
                            <HourglassEmpty style={{ width: 14 }} />
                            Pending signature
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
                {project.acceptanceCriteria &&
                  project.acceptanceCriteria.length > 0 && (
                    <SingleFileDisplay
                      file={
                        revisionAvailable
                          ? project.acceptanceCriteria[
                              project.acceptanceCriteria.length - 2
                            ]
                          : project.acceptanceCriteria[
                              project.acceptanceCriteria.length - 1
                            ]
                      }
                    />
                  )}
              </div>
            </Grid>
            {project.acceptanceCriteria &&
              project.acceptanceCriteria.length > 1 && (
                <Grid item xs={12}>
                  <div className="flex flex-end m-t-6 ">
                    <div
                      color="primary"
                      className="link m-t-6 m-b-6 text-right fs12 m-r-16"
                      onClick={() => setShowRevisionsModal(true)}
                    >
                      See revisions ({project.acceptanceCriteria.length})
                    </div>
                  </div>
                </Grid>
              )}
            <Grid item xs={12} className="input-item">
              <div
                className="link fs12 text-right m-t-6 m-b-6 m-r-6"
                onClick={() => setShowActivityPanel(true)}
              >
                Need a revision? Please contact your assignee.
              </div>
            </Grid>
          </Grid>
        </div>
      )}

      {(project.status === 'In progress' ||
        project.status === 'Pending acceptance' ||
        project.status === 'Complete') && (
        <ProjectDeliverables deliverables={project.deliverables} />
      )}

      <ModalPopUp
        title="Proceed with quote"
        variant="wide"
        setShowModal={setShowSignAndPayModal}
        showModal={showSignAndPayModal}
      >
        <ProjectSignAndPay
          setShowSignAndPayModal={setShowSignAndPayModal}
          handleProceedClick={handleProceedClick}
          bindPurchaseOrderNumber={bindPurchaseOrderNumber}
          purchaseOrderFiles={purchaseOrderFiles}
          setPurchaseOrderFiles={setPurchaseOrderFiles}
          setPaymentMethod={setPaymentMethod}
          paymentError={paymentError}
          purchaseOrderNumber={purchaseOrderNumber}
          processingPayment={processingPayment}
        />
      </ModalPopUp>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Payment submitted successfully</p>
            <p className="fs14 m-b-0">
              Your payment has been processed successfully.
            </p>
          </>
        }
        open={showToast}
        setOpen={setShowToast}
      />

      {project.status === 'Quote submitted' &&
      project.charges.length &&
      !project.charges[0].isPaid ? (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowSignAndPayModal(true)}
        >
          Start to proceed
        </Button>
      ) : null}

      <RevisionsModal
        setShowRevisionsModal={setShowRevisionsModal}
        showRevisionsModal={showRevisionsModal}
        project={project}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Step complete</p>
            <p className="fs14 m-b-0">
              Your document has been signed and your assignee will review the
              uploaded purchase order documents.
            </p>
          </>
        }
        open={poDocsAddedToast}
        setOpen={setPoDocsAddedToast}
      />
    </>
  )
}

export default ProjectActionsUser
